import { Record, RecordOf } from 'immutable';
import { DataSource, DataSources, EnrolmentStatus, Enrolment, Enrolments, EnrolmentVehicle } from 'services/resources';

export const DataSourceRecordFactory = Record<DataSource>({
  id: 0, // 0 does not exist
  dataSourceId: '',
  account: '',
  channelId: '',
  oemName: '',
});

export const DataSourcesRecordFactory = (data: DataSources) => data.map(DataSourceRecordFactory);

const EnrolmentVehicleRecordFactory = Record<EnrolmentVehicle>({
  id: 0, // 0 does not exist
  vin: '',
  make: '',
});

export const EnrolmentRecordFactory = Record<Enrolment>({
  id: 0, // 0 does not exist
  vehicle: EnrolmentVehicleRecordFactory(), // 0 does not exist
  dataSource: DataSourceRecordFactory(), // 0 does not exist
  status: EnrolmentStatus.UNKNOWN,
  createdAt: '',
  updatedAt: '',
});

export const EnrolmentsRecordFactory = (data: Enrolments) => data.map(EnrolmentRecordFactory);

export interface DataSourcesState {
  loading: boolean;
  values: DataSources;
}

export interface EnrolmentsState {
  loading: boolean;
  values: Enrolments;
}

export const DataSourcesStateRecordFactory = Record<DataSourcesState>({
  loading: false,
  values: DataSourcesRecordFactory([]),
});

export const EnrolmentsStateRecordFactory = Record<EnrolmentsState>({
  loading: false,
  values: EnrolmentsRecordFactory([]),
});

export interface TelematicsState {
  datasources: RecordOf<DataSourcesState>;
  enrolments: RecordOf<EnrolmentsState>;
}

export const TelematicsStateFactory = Record<TelematicsState>({
  datasources: DataSourcesStateRecordFactory(),
  enrolments: EnrolmentsStateRecordFactory(),
});
